import { useContext, useEffect, useState } from "react";
import { haveValue } from "../../../helper/common";
import useTranslator from "../../../hooks/useTranslator";
import TenantEmploymentModal from "./TenantEmploymentModal";
import { useNavigate } from "react-router-dom";
import TenantContext from "../../../context/tenant/TenantContext";
import constants from "../../../Utils/constants";

const AddDocumentsPending = (props) => {
  const navigate = useNavigate();
  const { user, setUser, id } = props;
  const { fetchTenantDocs } = useContext(TenantContext);
  const { _t } = useTranslator();
  const [showModal, setShowModal] = useState(false);
  const [tenantDocsData, setTenantDocsData] = useState([]);
  const [otherDocs, setOtherDocs] = useState([]);
  const [publicHousingDocs, setPublicHousingDocs] = useState([]);
  const [docFound, setDocFound] = useState(new Map());

  useEffect(() => {
    if (haveValue(user?._id)) fetchDocs();
  }, [user]);

  useEffect(() => {
    if (haveValue(tenantDocsData) && tenantDocsData.length >= 1) {
      const temp_map = new Map();
      const type_map = new Map();
      const other_type = [];
      const public_housing_docs_map = new Map();
      tenantDocsData.map((docs) => {
        if (docs?.from == "clave") {
          temp_map.set(docs?.type);
        }
        if (!type_map.has(docs?.type) && docs?.from != constants.others) {
          type_map.set(docs?.type, docs);
        }
        if (docs?.from == "others") {
          other_type.push(docs);
        }
        if (docs?.from == "public_housing_docs") {
          const existing = public_housing_docs_map.get(docs.type);
          if (
            !existing ||
            new Date(docs.created_at) > new Date(existing.created_at)
          ) {
            public_housing_docs_map.set(docs.type, docs);
          }
        }
      });
      const public_housing_docs_sorted = Array.from(
        public_housing_docs_map.values()
      ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      setOtherDocs(other_type);
      setPublicHousingDocs(public_housing_docs_sorted);
      setDocFound(type_map);
    }
  }, [tenantDocsData]);

  const handleCheckEmployment = () => {
    if (!haveValue(user?.employment_status)) {
      setShowModal(true);
    } else {
      navigate(`/tenant-check/docs/${id}`);
    }
  };

  const fetchDocs = async () => {
    const res = await fetchTenantDocs(id, true);

    setTenantDocsData(res.data.success_res.tenantDocs);
  };

  const handleNavigateTenantDocs = async () => {
    navigate(`/tenant-check/docs/${id}`);
  };

  return (
    <>
      <div className="big_tablebg tenant-doc-tile">
        {haveValue(user?._id) &&
          (!haveValue(user?.docs_uploaded) || !user?.docs_uploaded) && (
            <p className="notice-text">
              <img
                className="explaination-mark"
                src="/images/orange-explaination-mark.svg"
                alt=""
              />
              <span>
                {_t(
                  "youHaventProvidedTenantDocumentsYet",
                  "On ll side for created tt document"
                )}
              </span>
            </p>
          )}
        <div className="border-pd">
          <ul>
            {user?.docs_uploaded ? (
              <li
                className="d-flex tile-design border-0 p-0 m-0 cursor-pointer"
                onClick={handleNavigateTenantDocs}
              >
                <div className="tile-content-wrapper">
                  <div className="tile-content">
                    <h4 className="tile-heading">{_t("documents")}</h4>
                  </div>
                  <div className="d-flex align-items-center gap-24">
                    <div className="d-flex align-items-center gap-4 tile-btns-wrapper">
                      <button className="btn btngreen">
                        {_t("addMoreDocuments")}
                      </button>
                    </div>
                    <p>
                      {otherDocs.length +
                        publicHousingDocs.length +
                        docFound.size}{" "}
                      {_t("documents")}
                    </p>
                    <a href="#">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="19"
                        viewBox="0 0 11 19"
                        fill="none"
                      >
                        <path
                          d="M1 18L10 9.5L1 1"
                          stroke="#121212"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </li>
            ) : (
              <li
                className="d-flex tile-design border-0 p-0 m-0 cursor-pointer"
                onClick={handleCheckEmployment}
              >
                <div className="tile-content-wrapper">
                  <img src="/images/document-home-icon.svg" alt="" />
                  <div className="tile-content">
                    <h4 className="tile-heading">
                      {_t(
                        "provideTenantDocuments",
                        "Landlord side tile heading while creating a new Tenant"
                      )}
                    </h4>

                    <p className="tile-desc-completed">
                      {_t(
                        "provideTenantDocumentsDesc",
                        "Landlord side tile Description while creating a new Tenant"
                      )}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-4 tile-btns-wrapper ms-auto">
                    <button
                      className="btn btngreen "
                      disabled={!haveValue(user?._id)}
                      onClick={handleCheckEmployment}
                    >
                      {_t("complete")}
                    </button>
                  </div>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>

      {showModal && (
        <TenantEmploymentModal
          id={id}
          user={user}
          setUser={setUser}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};

export default AddDocumentsPending;
